import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { RateItemButtonsComponent } from './rate-item-buttons.component';

@NgModule({
  declarations: [
    RateItemButtonsComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
  ],
  exports: [
    RateItemButtonsComponent,
  ]
})
export class RateItemButtonsComponentModule { }